<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'tax-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
    ></app-report-top-filter-bar>

    <div class="tax-report-heading">
        <h3 class="tax-report-title">Tax report</h3>
        <span class="tax-report-subtitle">State-wise summary · registered states only</span>
    </div>

    <p-table
        #dt
        [tableStyle]="{ width: 'max-content' }"
        [value]="isLoading ? skeletonRows : dataList"
        *ngIf="isLoading || dataList?.length > 0"
        [autoLayout]="true"
        responsiveLayout="scroll"
        [paginator]="false"
        [customSort]="true"
        (onLazyLoad)="customSort($event)"
        [lazy]="true"
        [rows]="rows"
        showLoader="true"
        selectionMode="single"
    >
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="state" style="text-align: left">
                    State <p-sortIcon field="state"></p-sortIcon>
                </th>
                <th style="text-align: left">Rate</th>
                <!-- Taxable orders column hidden for now — TODO re-enable -->
                <th *ngIf="false" style="text-align: center">Taxable orders</th>
                <th pSortableColumn="grossSales" style="text-align: center">
                    Gross sales <p-sortIcon field="grossSales"></p-sortIcon>
                </th>
                <th pSortableColumn="taxCollected" style="text-align: center">
                    Tax collected <p-sortIcon field="taxCollected"></p-sortIcon>
                </th>
                <th style="text-align: center">Refunded tax</th>
                <th pSortableColumn="netTax" style="text-align: center">
                    Net tax <p-sortIcon field="netTax"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr *ngIf="isLoading; else dataRow">
                <td style="text-align: left"><p-skeleton width="4rem" height="1rem"></p-skeleton></td>
                <td style="text-align: left"><p-skeleton width="4rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
                <td style="text-align: center"><p-skeleton width="6rem" height="1rem"></p-skeleton></td>
            </tr>
            <ng-template #dataRow>
                <tr [pSelectableRow]="item">
                    <td style="text-align: left">{{ item.state }}</td>
                    <td style="text-align: left">{{ item.rate }}%</td>
                    <!-- Taxable orders column hidden for now — TODO re-enable -->
                    <td *ngIf="false" style="text-align: center">{{ item.taxableOrders }}</td>
                    <td style="text-align: center">{{ item.grossSales | currency | currencySpacing }}</td>
                    <td style="text-align: center">{{ item.taxCollected | currency | currencySpacing }}</td>
                    <td style="text-align: center">{{ item.refundedTax | currency | currencySpacing }}</td>
                    <td style="text-align: center">{{ item.netTax | currency | currencySpacing }}</td>
                </tr>
            </ng-template>
        </ng-template>

        <ng-template pTemplate="footer">
            <tr *ngIf="!isLoading && dataList?.length > 0">
                <td style="text-align: left"><strong>Total</strong></td>
                <td></td>
                <!-- Taxable orders column hidden for now — TODO re-enable -->
                <td *ngIf="false" style="text-align: center"><strong>{{ calculateCountTotal("taxableOrders") }}</strong></td>
                <td style="text-align: center"><strong>{{ calculateCurrencyTotal("grossSales") }}</strong></td>
                <td style="text-align: center"><strong>{{ calculateCurrencyTotal("taxCollected") }}</strong></td>
                <td style="text-align: center"><strong>{{ calculateCurrencyTotal("refundedTax") }}</strong></td>
                <td style="text-align: center"><strong>{{ calculateCurrencyTotal("netTax") }}</strong></td>
            </tr>
        </ng-template>
    </p-table>

    <div class="flex" *ngIf="!isLoading && dataList?.length == 0">
        <div class="text-align-center" style="width: 100%">
            <span class="control-description text-muted text-align-center">No data found!</span>
        </div>
    </div>

    <p-paginator
        *ngIf="!isLoading && dataList?.length > 0"
        [first]="first"
        (onPageChange)="onPageChange($event)"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Page: {currentPage} of {totalPages}, Total Records: {totalRecords}"
        #p
    >
    </p-paginator>

</div>
